import request from "root/js/request";

export const getExpensesCrossMPExport = async ({
  cabinet_id,
  marketplace,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/expense/export/",
    method: "get",
    params: {
      cabinet_id,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};
